import { Basecoat } from '../common';
import { Model, Cell } from '../model';
import { Options } from './options';
import { Scheduler } from '../scheduler';
export class Renderer extends Basecoat {
    constructor(graph, options) {
        super();
        this.graph = graph; // todo
        this.options = Options.get(options);
        this.model = new Model();
        this.model.graph = graph; // todo
        this.schedule = new Scheduler(graph, this.model); // todo
    }
    setRenderArea(area) {
        this.schedule.setRenderArea(area);
    }
    findViewByElem(elem) {
        if (elem == null) {
            return null;
        }
        const container = this.options.container;
        const target = typeof elem === 'string'
            ? container.querySelector(elem)
            : elem instanceof Element
                ? elem
                : elem[0];
        if (target) {
            const id = this.graph.view.findAttr('data-cell-id', target);
            if (id) {
                const views = this.schedule.views;
                return views[id].view;
            }
        }
        return null;
    }
    findViewByCell(cell) {
        if (cell == null) {
            return null;
        }
        const id = Cell.isCell(cell) ? cell.id : cell;
        const views = this.schedule.views;
        return views[id].view;
    }
    requestViewUpdate(view, flag, options = {}) {
        this.schedule.requestViewUpdate(view, flag, options);
    }
    isAsync() {
        return false;
    }
    dumpView(view, options = {}) {
        // todo
    }
    isViewMounted(view) {
        // todo
        return true;
    }
    findViewsInArea(rect, options = {}) {
        // todo
    }
    dispose() {
        this.schedule.dispose();
    }
}
//# sourceMappingURL=renderer.js.map